import { AuthClient } from '@auth/client';
import { createBrowserPasskeyClient, type PasskeyClient } from '@auth/ui-react';

/** auth backend のベース URL（AuthClient / PasskeyClient で共有）。 */
const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL || window.location.origin;

/**
 * AuthClient シングルトン
 *
 * @auth/client の AuthClient インスタンス。
 * アプリケーション全体で共有される。
 */
export const authClient = new AuthClient({
  baseUrl: AUTH_BASE_URL,
  autoRefresh: true,
  onAuthError: (error) => {
    // 開発環境でのデバッグ用ログ。本番ではコンソール出力なし。
    if (import.meta.env.DEV) {
      console.error('[AuthClient] 認証エラー:', error);
    }
  },
});

/**
 * PasskeyClient シングルトン。
 *
 * AuthClient と同一 baseUrl / 共有トークンストレージ（既定 `auth_` prefix）で配線し、
 * `@auth/ui-react` の AuthProvider に渡すことで LoginForm に passkey サインインを併存させる
 * （passkey ログインを全アプリへ昇格 / dashboard-passkey-ui 拡張）。
 */
export const passkeyClient: PasskeyClient = createBrowserPasskeyClient({ baseUrl: AUTH_BASE_URL });
